import { createFileRoute } from "@tanstack/react-router";
import PayeToolPage from "@/features/public/pages/tools/paye";

export const Route = createFileRoute("/(public)/_public/tools/paye")({
  component: PayeToolPage,
});
